cb.define(['common/common_VM.Extend.js'], function(common) {
	//var _util = require('../../../helpers/util');

	var ST_st_storecheck_VM_Extend = {
		doAction: function(name, viewmodel) {
			if(this[name])
				this[name](viewmodel);
		},
		init: function(viewmodel) {
			// viewmodel.addProperty("barcode",new cb.models.SimpleModel({
			//   "cFieldName": "barcode",
			//   "cItemName": "barcode",
			//   "iMaxLength": 255,
			//   "iFieldType": 1,
			//   "bEnum": false,
			//   "bMustSelect": false,
			//   "bHidden": true,
			//   "bSplit": false,
			//   "bExtend": false,
			//   "bCanModify": true,
			//   "iMaxShowLen": 255,
			//   "bNeedSum": false,
			//   "bShowIt": false,
			//   "bFilter": true,
			//   "bIsNull": true,
			//   "bPrintCaption": true,
			//   "bJointQuery": false,
			//   "bPrintUpCase": false,
			//   "bSelfDefine": false,
			//   "bMain": false,
			//   "cControlType": "Input"
			// }));

			//初始化barcode wangyda
			common.initBarcodeModel(viewmodel);
			//============================================================barcode related
			//扫码
			viewmodel.get("barcode").on('enter', function(data) {
				//字段对照
				var fields = {
					mainid: 'mainid',
					product: 'product',
					productcode: 'product_cCode',
					productname: 'product_cName',
					productsku: 'productsku',
					barcode: 'barcode',
					batchno: 'batchno',
					producedate: 'producedate',
					invaliddate: 'invaliddate',
					productskucode: 'productsku_cCode',
					weight: 'weight',
					quantity: 'quantity',
					unit: 'unit',
					unitname: 'unitName',
					accountQty: 'accountQty',
					accountWeight: 'accountWeight',
					accountPrice: "accountPrice",
					isbatch: 'isBatchManage',
					isexpirydatemanage: 'isExpiryDateManage'
				};

				return onBarCodeEnter(data, fields);
				// return common.onBarCodeEnter(data, viewmodel, fields, afterBarcodeEnter);
				// return common.onBarCodeEnter(data, viewmodel, rowObj, afterBarcodeEnter);
			});

			var onBarCodeEnter = function(data, fields) {
				if(beforeBarcodeEnter() === true) {
					return common.onBarCodeEnter(data, viewmodel, fields, afterBarcodeEnter);
				}
			};

			var beforeBarcodeEnter = function() {
				let ret = true;
				let warehouse = viewmodel.get("warehouse").getValue();

				if(null == warehouse || warehouse === undefined || warehouse == '') {
					cb.utils.alert('未选择仓库！', 'error');
					ret = false;
				}

				return ret;
			};

			var afterBarcodeEnter = function(pData, rowIndex) {
				var isBatchManage = pData.isBatchManage;
				if(!isBatchManage || (isBatchManage && detailsModel.getCellValue(rowIndex, 'batchno'))) {
					updateRowStockAndStatus(rowIndex);
				}
			};

			// viewmodel.addProperty("attachment",new cb.models.SimpleModel({
			//   "cFieldName": "attachment",
			//   "cItemName": "attachment",
			//   "iMaxLength": 255,
			//   "iFieldType": 1,
			//   "bEnum": false,
			//   "bMustSelect": false,
			//   "bHidden": true,
			//   "bSplit": false,
			//   "bExtend": false,
			//   "bCanModify": true,
			//   "iMaxShowLen": 255,
			//   "bNeedSum": false,
			//   "bShowIt": false,
			//   "bFilter": true,
			//   "bIsNull": true,
			//   "bPrintCaption": true,
			//   "bJointQuery": false,
			//   "bPrintUpCase": false,
			//   "bSelfDefine": false,
			//   "bMain": false,
			//   "cControlType": "TextImport"
			// }));

			// ====== 共用变量 ======
			var self = this;
			var detailsModel = viewmodel.get("details");

			//向后台传递行号
			// detailsModel.setState('orderField', 'rowno');

			// var attachmentModel = viewmodel.get("attachment");
			var originDataSource = null;
			var showAccountItems = false; // 参数：是否显示帐存
			var checkInventorySheetGenerate = false; // 参数：是否升单
			var isBrowse = false;
			var curStatus = 0;

			viewmodel.on('afterEdit', function() {
				var actionsStates = [];
				// ====== 浏览态表体行显示删行按钮 ======
				var rows = detailsModel.getRows();
				for(var i = 0; i < rows.length; i++) {
					var actionState = {};
					actionState["btnDeleteDetail"] = {
						visible: true
					};
					actionsStates.push(actionState);
				}
				detailsModel.setActionsState(actionsStates);
			});

			viewmodel.on("afterLoadData", function(args) {
				// ====== 保存原始列表数据的一份备份 ======
				// if (null == originDataSource) {
				originDataSource = [];
				let originRows = detailsModel.getData();
				originRows.forEach(row => {
					originDataSource.push(row);
				});
				// }

				// ====== 当前是否浏览态 ======
				isBrowse = viewmodel.getParams().mode === 'browse' ? true : false;

				// ====== 当前单据状态 ======
				let statusValue = viewmodel.get('status').getValue();
				if(!(null == statusValue || statusValue == undefined)) {
					curStatus = parseInt(statusValue);
				} else {
					curStatus = null;
				}

				// ====== 查询参数：是否显示帐存 ======
				var queryOptionProxy = cb.rest.DynamicProxy.create({
					settle: {
						url: '/option/getOptionsByParams?token=28f9169d2e2a491bb1804138e4357e29',
						method: 'POST'
					}
				});

				var params = {
					optionId: 'business_option',
					name: 'accountqtystorecheck',
					groupCode: 'bo0102'
				};

				queryOptionProxy.settle(params, (err, result) => {
					if(err) {
						return;
					}

					if(result === undefined) {
						return;
					}

					if(result.length > 0) {
						showAccountItems = result[0].value;
					} else {
						showAccountItems = false;
					}

					// ====== 根据参数是否显示帐存 ======
					if(showAccountItems) {
						detailsModel.setColumnState('accountQty', 'bShowIt', true);
						detailsModel.setColumnState('accountWeight', 'bShowIt', true);
						detailsModel.setColumnState('accountPrice', 'bShowIt', true);
					} else {
						detailsModel.setColumnState('accountQty', 'bShowIt', false);
						detailsModel.setColumnState('accountWeight', 'bShowIt', false);
						detailsModel.setColumnState('accountPrice', 'bShowIt', false);
					}
				});

				// ====== 查询参数：是否升单 ======
				var queryOptionProxy = cb.rest.DynamicProxy.create({
					settle: {
						url: '/option/getOptionsByParams?token=28f9169d2e2a491bb1804138e4357e29',
						method: 'POST'
					}
				});

				var params = {
					optionId: 'business_option',
					name: 'checkInventorySheetGenerate',
					groupCode: 'bo0102'
				};

				queryOptionProxy.settle(params, (err, result) => {
					if(err) {
						return;
					}

					if(result === undefined) {
						return;
					}

					if(result.length > 0) {
						checkInventorySheetGenerate = result[0].value;
					} else {
						checkInventorySheetGenerate = false;
					}

					// ====== 根据升单参数、浏览态、单据状态 决定：联查按钮 可见性 ======
					if(checkInventorySheetGenerate && isBrowse && curStatus == 1) {
            if (viewmodel.get("btnQueryOthOut")) {
              viewmodel.get("btnQueryOthOut").setVisible(true);
            }

            if (viewmodel.get("btnQueryOthIn")) {
              viewmodel.get("btnQueryOthIn").setVisible(true);
            }

					} else {
            if (viewmodel.get("btnQueryOthOut")) {
              viewmodel.get("btnQueryOthOut").setVisible(false);
            }

            if (viewmodel.get("btnQueryOthIn")) {
              viewmodel.get("btnQueryOthIn").setVisible(false);
            }
					}

				});


				if (!isBrowse) {
          // ====== 校验仓库是否有未复核的快速盘点以及盘点计划 ======
          var storecheckId = viewmodel.get("id").getValue();
          var wareh = viewmodel.get("warehouse").getValue();

          var wParams = {
            storecheck: storecheckId,
            wareh: wareh
          };

          var existStoreCheck = cb.rest.DynamicProxy.create({
            settle: {
              url: '/billingustock/existStoreCheckOrPlan',
              method: 'POST'
            }
          });

          existStoreCheck.settle(wParams, (err, result) => {
            if(err) {
              cb.utils.alert(err.message, 'error');
              return;
            }

            if(result === undefined) {
              cb.utils.alert("查询盘点数据异常！", 'error');
              return;
            }

            if(result != null && result != undefined && result !== '') {
              if(result == true || result == 'true') {
                cb.utils.alert("该仓库下存在未复核的盘点数据，不允许编辑！", 'error');
                viewmodel.get("warehouse").setValue(null);
                viewmodel.get("warehouse_name").setValue('');
              }
            }
          });
        }

        // ====== 根据是否浏览态确定按钮可见性 ======
        handleButtonsVisibilityByBrowseMode(isBrowse);

        /*
				// ====== 根据是否浏览态确定 保存、取消、返回 按钮可见性 ======
				if(isBrowse) {
					viewmodel.get("btnSave").setVisible(false);
					if (viewmodel.get("btnSaveAndAudit")) {
            viewmodel.get("btnSaveAndAudit").setVisible(false);
          }
					viewmodel.get("btnAbandon").setVisible(false);
					viewmodel.get("btnAbandonEditt").setVisible(true);
					viewmodel.get("btnAbandonEditt").setDisabled(false);

					// ====== 增行、删行、导入 按钮 ======
					viewmodel.get("btnAddDetail").setVisible(false);
					var actionsStates = [];
					// ====== 浏览态表体行隐藏删行按钮 ======
					var rows = detailsModel.getRows();
					for(var i = 0; i < rows.length; i++) {
						var actionState = {};
						actionState["btnDeleteDetail"] = {
							visible: false
						};
						actionsStates.push(actionState);
					}
					detailsModel.setActionsState(actionsStates);

					// ====== 表体导入按钮 ======
					viewmodel.get("btnAttachment").setVisible(false);

					// ====== 浏览态显示：打印、导出、
          if (viewmodel.get("btnPreview")) {
            viewmodel.get("btnPreview").setVisible(true);
            viewmodel.get("btnPreview").setDisabled(false);
          }

          if (viewmodel.get("btnExport")) {
            viewmodel.get("btnExport").setVisible(true);
            viewmodel.get("btnExport").setDisabled(false);
          }
				} else {
				  // ===== 编辑态隐藏：打印、提交、导出... ======
          if (viewmodel.get("btnPreview")) {
            viewmodel.get("btnPreview").setVisible(false);
          }

          if (viewmodel.get("btnRowAudit")) {
            viewmodel.get("btnRowAudit").setVisible(false);
          }

          if (viewmodel.get("btnExport")) {
            viewmodel.get("btnExport").setVisible(false);
          }

					// ====== 校验仓库是否有未复核的快速盘点以及盘点计划 ======
					var storecheckId = viewmodel.get("id").getValue();
					var wareh = viewmodel.get("warehouse").getValue();

					var wParams = {
						storecheck: storecheckId,
						wareh: wareh
					};

					var existStoreCheck = cb.rest.DynamicProxy.create({
						settle: {
							url: '/billingustock/existStoreCheckOrPlan',
							method: 'POST'
						}
					});

					existStoreCheck.settle(wParams, (err, result) => {
						if(err) {
							cb.utils.alert(err.message, 'error');
							return;
						}

						if(result === undefined) {
							cb.utils.alert("查询盘点数据异常！", 'error');
							return;
						}

						if(result != null && result != undefined && result !== '') {
							if(result == true || result == 'true') {
								cb.utils.alert("该仓库下存在未复核的盘点数据，不允许编辑！", 'error');
								viewmodel.get("warehouse").setValue(null);
								viewmodel.get("warehouse_name").setValue('');
							}
						}
					});
				}
				*/

				// ====== 未提交状态：浏览态显示 编辑、删除 ======
				if(curStatus == 0) {
					if(isBrowse) {
						viewmodel.get("btnEdit").setVisible(true);
						viewmodel.get("btnEdit").setDisabled(false);
						viewmodel.get("btnDelete").setVisible(true);
						viewmodel.get("btnDelete").setDisabled(false);
            if (viewmodel.get("btnSaveAndAudit")) {
              viewmodel.get("btnSaveAndAudit").setVisible(false);
            }

            if (viewmodel.get("btnRowAudit")) {
              viewmodel.get("btnRowAudit").setVisible(true);
            }
					} else {
						viewmodel.get("btnEdit").setVisible(false);
						viewmodel.get("btnDelete").setVisible(false);

            if (viewmodel.get("btnRowAudit")) {
              viewmodel.get("btnRowAudit").setVisible(false);
            }
					}
				}

				// ====== 已提交状态：是否显示 差异数量、差异类型 列 ======
				if(curStatus == 2) {
					detailsModel.setColumnState('vQuantity', 'bShowIt', true);
					detailsModel.setColumnState('vType', 'bShowIt', true);
				} else {
					detailsModel.setColumnState('vQuantity', 'bShowIt', false);
					detailsModel.setColumnState('vType', 'bShowIt', false);
				}

				// ====== 已复核状态：隐藏 表体删行 按钮 ======
				// ====== 已复核 表体显示：差异类型 和 差异数量 列 ======
				if(curStatus == 1) {
					var actionsStates = [];
					var rows = detailsModel.getRows();

					for(var i = 0; i < rows.length; i++) {
						var actionState = {};
						actionState["btnDeleteDetail"] = {
							visible: false
						};
						actionsStates.push(actionState);
					}

					detailsModel.setActionsState(actionsStates);

					// ====== 修改 cFieldName 后，此处可以省略 ======
					// ====== 2018-02-07 ======
					// batchUpdateRowStockAndStatus(rows);

					detailsModel.setColumnState('vQuantity', 'bShowIt', true);
					detailsModel.setColumnState('vType', 'bShowIt', true);
				}

				// ====== 根据单据状态：是否显示 单据状态 ======
				if(null != curStatus) {
					viewmodel.get("status").setVisible(true);
					viewmodel.get("status").setDisabled(true);
				} else {
					viewmodel.get("status").setVisible(false);
					viewmodel.get("status").setDisabled(true);
				}

				// ====== 复盘状态 只显示有差异数据行 ======
				if(curStatus == 3) {
					if(isBrowse) {
						viewmodel.get("btnEdit").setVisible(true);
						viewmodel.get("btnEdit").setDisabled(false);

            if (viewmodel.get("btnRowAudit")) {
              viewmodel.get("btnRowAudit").setVisible(true);
            }
					} else {
						viewmodel.get("btnEdit").setVisible(false);

            if (viewmodel.get("btnRowAudit")) {
              viewmodel.get("btnRowAudit").setVisible(false);
            }
					}

					// let rowsLength = detailsModel.getRows().length;

					// for (var i = 0; i < rowsLength; i++) {
					//   updateRowStockAndStatus(i);
					// }

					var newRows = [];
					originDataSource.forEach(row => {
						let curAccountQty = row.accountQty;
						let curQuantity = row.quantity;
						// let curAccountQty = parseInt(row.accountQty);
						// let curQuantity = parseInt(row.quantity);
						if(curAccountQty != curQuantity) {
							newRows.push(row);
						}
					});

					// detailsModel.setDataSource(newRows);
					batchUpdateRowStockAndStatus(newRows);
					// detailsModel.setDirty(false);
				}
			});

			// ====== 公共批次号管理 ======
			if(detailsModel) {
				//单元格编辑之前判断该行商品是否启用批次管理和效期管理
				detailsModel.on('rowColChange', function(args) {
					return common.bacthnoAndExpiryDateManage(args, detailsModel);
				});
			}

			// ====== 联查其他出库单 ======
			viewmodel.on('queryothout', function(args) {
				var originid = viewmodel.get("id").getValue();
				var proxy = cb.rest.DynamicProxy.create({
					ensure: {
						url: args.cSvcUrl,
						method: args.cHttpMethod
					}
				});
				var params = {
					action: 'queryothout',
					billnum: 'st_storecheck',
					data: JSON.stringify(originid)
				}
				proxy.ensure(params, function(err, result) {
					if(err) {
						cb.utils.alert(err.message, 'error');
						return;
					}
					if(result != undefined) {
						// cb.utils.alert('操作成功', 'success');
						viewmodel.execute('refresh');
						var params = {
							mode: 'edit',
							readOnly: true,
							id: JSON.parse(result).id
						};
						var data = {
							billtype: 'voucher',
							billno: JSON.parse(result).billno,
							params: params
						};
						cb.loader.runCommandLine('bill', data, viewmodel);
					}

				});
			});

			// ====== 联查其他入库单 ======
			viewmodel.on('queryothin', function(args) {
				var originid = viewmodel.get("id").getValue();
				var proxy = cb.rest.DynamicProxy.create({
					ensure: {
						url: args.cSvcUrl,
						method: args.cHttpMethod
					}
				});
				var params = {
					action: 'queryothin',
					billnum: 'st_storecheck',
					data: JSON.stringify(originid)
				}
				proxy.ensure(params, function(err, result) {
					if(err) {
						cb.utils.alert(err.message, 'error');
						return;
					}
					// cb.utils.alert('操作成功', 'success');
					viewmodel.execute('refresh');
					var params = {
						mode: 'edit',
						readOnly: true,
						id: JSON.parse(result).id
					};
					var data = {
						billtype: 'voucher',
						billno: JSON.parse(result).billno,
						params: params
					};
					cb.loader.runCommandLine('bill', data, viewmodel);
				});
			});


			// *************************************************************************************************************
      // *                                           自 定 义 函 数 区                                                *
      // *************************************************************************************************************
      // ====== 根据是否浏览态确定按钮的一般可见性(不包含复杂业务逻辑) ======
      var handleButtonsVisibilityByBrowseMode = function(isBrowse) {
        if(isBrowse) {
          viewmodel.get("btnSave").setVisible(false);
          if (viewmodel.get("btnSaveAndAudit")) {
            viewmodel.get("btnSaveAndAudit").setVisible(false);
          }
          viewmodel.get("btnAbandon").setVisible(false);
          viewmodel.get("btnAbandonEditt").setVisible(true);
          viewmodel.get("btnAbandonEditt").setDisabled(false);

          // ====== 增行、删行、导入 按钮 ======
          viewmodel.get("btnAddDetail").setVisible(false);
          var actionsStates = [];
          // ====== 浏览态表体行隐藏删行按钮 ======
          var rows = detailsModel.getRows();
          for(var i = 0; i < rows.length; i++) {
            var actionState = {};
            actionState["btnDeleteDetail"] = {
              visible: false
            };
            actionsStates.push(actionState);
          }
          detailsModel.setActionsState(actionsStates);

          // ====== 表体导入按钮 ======
          viewmodel.get("btnAttachment").setVisible(false);

          // ====== 浏览态显示：打印、导出、
          if (viewmodel.get("btnPreview")) {
            viewmodel.get("btnPreview").setVisible(true);
            viewmodel.get("btnPreview").setDisabled(false);
          }

          if (viewmodel.get("btnExport")) {
            viewmodel.get("btnExport").setVisible(true);
            viewmodel.get("btnExport").setDisabled(false);
          }
        } else {
          // ===== 编辑态隐藏：打印、提交、导出... ======
          if (viewmodel.get("btnPreview")) {
            viewmodel.get("btnPreview").setVisible(false);
          }

          if (viewmodel.get("btnRowAudit")) {
            viewmodel.get("btnRowAudit").setVisible(false);
          }

          if (viewmodel.get("btnExport")) {
            viewmodel.get("btnExport").setVisible(false);
          }
        }
      };

			// ====== 商品查询、库存查询 =====================================================================================
			var appendNewRow = function(mainid, data, quantity = 1) {
				// let pData = data.data.recordList[0];
				let pData = data.data[0];
				let isBatchManage = pData.isBatchManage;
				let accountWeight = null;
				let batchno = null;
				let producedate = null;
				let invaliddate = null;
				let weight = null;

				if(!isBatchManage) {
					accountWeight = pData.productskus[0].sku_define1;
					weight = accountWeight;
				} else {
					batchno = pData.productskus[0].batchno;

					if(null != batchno && batchno != undefined) {
						producedate = pData.productskus[0].producedate;
						invaliddate = pData.productskus[0].invaliddate;
						let define1 = pData.productskus[0].batchno_define1;

						accountWeight = define1;
						weight = define1;
					}
				}

				detailsModel.appendRow({
					//"accountQty" : 1,
					//"id" : result.recordList[0].productskus[0].skuId,
					"mainid": mainid,
					"product": pData.productskus[0].product,
					"product_cCode": pData.cCode,
					"product_cName": pData.cName,
					"productsku": pData.productskus[0].skuId,
					"barcode": pData.productskus[0].barCode,
					"batchno": batchno,
					"producedate": producedate,
					"invaliddate": invaliddate,
					"productsku_cCode": pData.productskus[0].skuCode,
					"weight": weight,
					//"pubts" : "2017-09-26 16:53:30",
					"quantity": quantity,
					"unit": pData.oUnitId,
					"unitName": pData.unitName,
					"accountWeight": accountWeight,
					"accountPrice": pData.productskus[0].skuSalePrice,
					"isBatchManage": isBatchManage,

					// ====== 商品规格 ======
					"free1": pData.productskus[0].free1 ? pData.productskus[0].free1 : null,
					"free2": pData.productskus[0].free2 ? pData.productskus[0].free2 : null,
					"free3": pData.productskus[0].free3 ? pData.productskus[0].free3 : null,
					"free4": pData.productskus[0].free4 ? pData.productskus[0].free4 : null,
					"free5": pData.productskus[0].free5 ? pData.productskus[0].free5 : null,
					"free6": pData.productskus[0].free6 ? pData.productskus[0].free6 : null,
					"free7": pData.productskus[0].free7 ? pData.productskus[0].free7 : null,
					"free8": pData.productskus[0].free8 ? pData.productskus[0].free8 : null,
					"free9": pData.productskus[0].free9 ? pData.productskus[0].free9 : null,
					"free10": pData.productskus[0].free10 ? pData.productskus[0].free10 : null,

					// ====== 批次属性 ======
					"define1": pData.productskus[0].batchno_define1 ? pData.productskus[0].batchno_define1 : null,
					"define2": pData.productskus[0].batchno_define2 ? pData.productskus[0].batchno_define2 : null,
					"define3": pData.productskus[0].batchno_define3 ? pData.productskus[0].batchno_define3 : null,
					"define4": pData.productskus[0].batchno_define4 ? pData.productskus[0].batchno_define4 : null,
					"define5": pData.productskus[0].batchno_define5 ? pData.productskus[0].batchno_define5 : null,
					"define6": pData.productskus[0].batchno_define6 ? pData.productskus[0].batchno_define6 : null,
					"define7": pData.productskus[0].batchno_define7 ? pData.productskus[0].batchno_define7 : null,
					"define8": pData.productskus[0].batchno_define8 ? pData.productskus[0].batchno_define8 : null,
					"define9": pData.productskus[0].batchno_define9 ? pData.productskus[0].batchno_define9 : null,
					"define10": pData.productskus[0].batchno_define10 ? pData.productskus[0].batchno_define10 : null,
					"define11": pData.productskus[0].batchno_define11 ? pData.productskus[0].batchno_define11 : null,
					"define12": pData.productskus[0].batchno_define12 ? pData.productskus[0].batchno_define12 : null,
					"define13": pData.productskus[0].batchno_define13 ? pData.productskus[0].batchno_define13 : null,
					"define14": pData.productskus[0].batchno_define14 ? pData.productskus[0].batchno_define14 : null,
					"define15": pData.productskus[0].batchno_define15 ? pData.productskus[0].batchno_define15 : null,
					"define16": pData.productskus[0].batchno_define16 ? pData.productskus[0].batchno_define16 : null,
					"define17": pData.productskus[0].batchno_define17 ? pData.productskus[0].batchno_define17 : null,
					"define18": pData.productskus[0].batchno_define18 ? pData.productskus[0].batchno_define18 : null,
					"define19": pData.productskus[0].batchno_define19 ? pData.productskus[0].batchno_define19 : null,
					"define20": pData.productskus[0].batchno_define20 ? pData.productskus[0].batchno_define20 : null,
					"define21": pData.productskus[0].batchno_define21 ? pData.productskus[0].batchno_define21 : null,
					"define22": pData.productskus[0].batchno_define22 ? pData.productskus[0].batchno_define22 : null,
					"define23": pData.productskus[0].batchno_define23 ? pData.productskus[0].batchno_define23 : null,
					"define24": pData.productskus[0].batchno_define24 ? pData.productskus[0].batchno_define24 : null,
					"define25": pData.productskus[0].batchno_define25 ? pData.productskus[0].batchno_define25 : null,
					"define26": pData.productskus[0].batchno_define26 ? pData.productskus[0].batchno_define26 : null,
					"define27": pData.productskus[0].batchno_define27 ? pData.productskus[0].batchno_define27 : null,
					"define28": pData.productskus[0].batchno_define28 ? pData.productskus[0].batchno_define28 : null,
					"define29": pData.productskus[0].batchno_define29 ? pData.productskus[0].batchno_define29 : null,
					"define30": pData.productskus[0].batchno_define30 ? pData.productskus[0].batchno_define30 : null,

					// ====== 商品自定义项 ======
					"prodefine1": pData.define1 ? pData.define1 : null,
					"prodefine2": pData.define2 ? pData.define2 : null,
					"prodefine3": pData.define3 ? pData.define3 : null,
					"prodefine4": pData.define4 ? pData.define4 : null,
					"prodefine5": pData.define5 ? pData.define5 : null,
					"prodefine6": pData.define6 ? pData.define6 : null,
					"prodefine7": pData.define7 ? pData.define7 : null,
					"prodefine8": pData.define8 ? pData.define8 : null,
					"prodefine9": pData.define9 ? pData.define9 : null,
					"prodefine10": pData.define10 ? pData.define10 : null,
					"prodefine11": pData.define11 ? pData.define11 : null,
					"prodefine12": pData.define12 ? pData.define12 : null,
					"prodefine13": pData.define13 ? pData.define13 : null,
					"prodefine14": pData.define14 ? pData.define14 : null,
					"prodefine15": pData.define15 ? pData.define15 : null,
					"prodefine16": pData.define16 ? pData.define16 : null,
					"prodefine17": pData.define17 ? pData.define17 : null,
					"prodefine18": pData.define18 ? pData.define18 : null,
					"prodefine19": pData.define19 ? pData.define19 : null,
					"prodefine20": pData.define20 ? pData.define20 : null,
					"prodefine21": pData.define21 ? pData.define21 : null,
					"prodefine22": pData.define22 ? pData.define22 : null,
					"prodefine23": pData.define23 ? pData.define23 : null,
					"prodefine24": pData.define24 ? pData.define24 : null,
					"prodefine25": pData.define25 ? pData.define25 : null,
					"prodefine26": pData.define26 ? pData.define26 : null,
					"prodefine27": pData.define27 ? pData.define27 : null,
					"prodefine28": pData.define28 ? pData.define28 : null,
					"prodefine29": pData.define29 ? pData.define29 : null,
					"prodefine30": pData.define30 ? pData.define30 : null,

					// ====== 商品自定义项 ======
					"skudefine1": pData.productskus[0].sku_define1 ? pData.productskus[0].sku_define1 : null,
					"skudefine2": pData.productskus[0].sku_define2 ? pData.productskus[0].sku_define2 : null,
					"skudefine3": pData.productskus[0].sku_define3 ? pData.productskus[0].sku_define3 : null,
					"skudefine4": pData.productskus[0].sku_define4 ? pData.productskus[0].sku_define4 : null,
					"skudefine5": pData.productskus[0].sku_define5 ? pData.productskus[0].sku_define5 : null,
					"skudefine6": pData.productskus[0].sku_define6 ? pData.productskus[0].sku_define6 : null,
					"skudefine7": pData.productskus[0].sku_define7 ? pData.productskus[0].sku_define7 : null,
					"skudefine8": pData.productskus[0].sku_define8 ? pData.productskus[0].sku_define8 : null,
					"skudefine9": pData.productskus[0].sku_define9 ? pData.productskus[0].sku_define9 : null,
					"skudefine10": pData.productskus[0].sku_define10 ? pData.productskus[0].sku_define10 : null,
					"skudefine11": pData.productskus[0].sku_define11 ? pData.productskus[0].sku_define11 : null,
					"skudefine12": pData.productskus[0].sku_define12 ? pData.productskus[0].sku_define12 : null,
					"skudefine13": pData.productskus[0].sku_define13 ? pData.productskus[0].sku_define13 : null,
					"skudefine14": pData.productskus[0].sku_define14 ? pData.productskus[0].sku_define14 : null,
					"skudefine15": pData.productskus[0].sku_define15 ? pData.productskus[0].sku_define15 : null,
					"skudefine16": pData.productskus[0].sku_define16 ? pData.productskus[0].sku_define16 : null,
					"skudefine17": pData.productskus[0].sku_define17 ? pData.productskus[0].sku_define17 : null,
					"skudefine18": pData.productskus[0].sku_define18 ? pData.productskus[0].sku_define18 : null,
					"skudefine19": pData.productskus[0].sku_define19 ? pData.productskus[0].sku_define19 : null,
					"skudefine20": pData.productskus[0].sku_define20 ? pData.productskus[0].sku_define20 : null,
					"skudefine21": pData.productskus[0].sku_define21 ? pData.productskus[0].sku_define21 : null,
					"skudefine22": pData.productskus[0].sku_define22 ? pData.productskus[0].sku_define22 : null,
					"skudefine23": pData.productskus[0].sku_define23 ? pData.productskus[0].sku_define23 : null,
					"skudefine24": pData.productskus[0].sku_define24 ? pData.productskus[0].sku_define24 : null,
					"skudefine25": pData.productskus[0].sku_define25 ? pData.productskus[0].sku_define25 : null,
					"skudefine26": pData.productskus[0].sku_define26 ? pData.productskus[0].sku_define26 : null,
					"skudefine27": pData.productskus[0].sku_define27 ? pData.productskus[0].sku_define27 : null,
					"skudefine28": pData.productskus[0].sku_define28 ? pData.productskus[0].sku_define28 : null,
					"skudefine29": pData.productskus[0].sku_define29 ? pData.productskus[0].sku_define29 : null,
					"skudefine30": pData.productskus[0].sku_define30 ? pData.productskus[0].sku_define30 : null,
					"skudefine31": pData.productskus[0].sku_define31 ? pData.productskus[0].sku_define31 : null,
					"skudefine32": pData.productskus[0].sku_define32 ? pData.productskus[0].sku_define32 : null,
					"skudefine33": pData.productskus[0].sku_define33 ? pData.productskus[0].sku_define33 : null,
					"skudefine34": pData.productskus[0].sku_define34 ? pData.productskus[0].sku_define34 : null,
					"skudefine35": pData.productskus[0].sku_define35 ? pData.productskus[0].sku_define35 : null,
					"skudefine36": pData.productskus[0].sku_define36 ? pData.productskus[0].sku_define36 : null,
					"skudefine37": pData.productskus[0].sku_define37 ? pData.productskus[0].sku_define37 : null,
					"skudefine38": pData.productskus[0].sku_define38 ? pData.productskus[0].sku_define38 : null,
					"skudefine39": pData.productskus[0].sku_define39 ? pData.productskus[0].sku_define39 : null,
					"skudefine40": pData.productskus[0].sku_define40 ? pData.productskus[0].sku_define40 : null,
					"skudefine41": pData.productskus[0].sku_define41 ? pData.productskus[0].sku_define41 : null,
					"skudefine42": pData.productskus[0].sku_define42 ? pData.productskus[0].sku_define42 : null,
					"skudefine43": pData.productskus[0].sku_define43 ? pData.productskus[0].sku_define43 : null,
					"skudefine44": pData.productskus[0].sku_define44 ? pData.productskus[0].sku_define44 : null,
					"skudefine45": pData.productskus[0].sku_define45 ? pData.productskus[0].sku_define45 : null,
					"skudefine46": pData.productskus[0].sku_define46 ? pData.productskus[0].sku_define46 : null,
					"skudefine47": pData.productskus[0].sku_define47 ? pData.productskus[0].sku_define47 : null,
					"skudefine48": pData.productskus[0].sku_define48 ? pData.productskus[0].sku_define48 : null,
					"skudefine49": pData.productskus[0].sku_define49 ? pData.productskus[0].sku_define49 : null,
					"skudefine50": pData.productskus[0].sku_define50 ? pData.productskus[0].sku_define50 : null,
					"skudefine51": pData.productskus[0].sku_define51 ? pData.productskus[0].sku_define51 : null,
					"skudefine52": pData.productskus[0].sku_define52 ? pData.productskus[0].sku_define52 : null,
					"skudefine53": pData.productskus[0].sku_define53 ? pData.productskus[0].sku_define53 : null,
					"skudefine54": pData.productskus[0].sku_define54 ? pData.productskus[0].sku_define54 : null,
					"skudefine55": pData.productskus[0].sku_define55 ? pData.productskus[0].sku_define55 : null,
					"skudefine56": pData.productskus[0].sku_define56 ? pData.productskus[0].sku_define56 : null,
					"skudefine57": pData.productskus[0].sku_define57 ? pData.productskus[0].sku_define57 : null,
					"skudefine58": pData.productskus[0].sku_define58 ? pData.productskus[0].sku_define58 : null,
					"skudefine59": pData.productskus[0].sku_define59 ? pData.productskus[0].sku_define59 : null,
					"skudefine60": pData.productskus[0].sku_define60 ? pData.productskus[0].sku_define60 : null
				})
			};

			var updateCurrentRow = function(curRowIndex, mainid, data, quantity = 1) {
				// let pData = data.data.recordList[0];
				let pData = data.data[0];
				let isBatchManage = pData.isBatchManage;
				let accountWeight = null;
				let batchno = null;
				let producedate = null;
				let invaliddate = null;
				let weight = null;

				if(!isBatchManage) {
					accountWeight = pData.productskus[0].sku_define1;
					weight = accountWeight;
				} else {
					batchno = pData.productskus[0].batchno;

					if(null != batchno && batchno != undefined) {
						producedate = pData.productskus[0].producedate;
						invaliddate = pData.productskus[0].invaliddate;
						let define1 = pData.productskus[0].batchno_define1;

						accountWeight = define1;
						weight = define1;
					}
				}

				detailsModel.updateRow(curRowIndex, {
					"mainid": mainid,
					"product": pData.productskus[0].product,
					"product_cCode": pData.cCode,
					"product_cName": pData.cName,
					"productsku": pData.productskus[0].skuId,
					"barcode": pData.productskus[0].barCode,
					"batchno": batchno,
					"producedate": producedate,
					"invaliddate": invaliddate,
					"productsku_cCode": pData.productskus[0].skuCode,
					"weight": weight,
					//"pubts" : "2017-09-26 16:53:30",
					"quantity": quantity,
					"unit": pData.oUnitId,
					"unitName": pData.unitName,
					"accountWeight": accountWeight,
					"accountPrice": pData.productskus[0].skuSalePrice,
					"isBatchManage": isBatchManage,

					"free1": pData.productskus[0].free1 ? pData.productskus[0].free1 : null,
					"free2": pData.productskus[0].free2 ? pData.productskus[0].free2 : null,
					"free3": pData.productskus[0].free3 ? pData.productskus[0].free3 : null,
					"free4": pData.productskus[0].free4 ? pData.productskus[0].free4 : null,
					"free5": pData.productskus[0].free5 ? pData.productskus[0].free5 : null,
					"free6": pData.productskus[0].free6 ? pData.productskus[0].free6 : null,
					"free7": pData.productskus[0].free7 ? pData.productskus[0].free7 : null,
					"free8": pData.productskus[0].free8 ? pData.productskus[0].free8 : null,
					"free9": pData.productskus[0].free9 ? pData.productskus[0].free9 : null,
					"free10": pData.productskus[0].free10 ? pData.productskus[0].free10 : null,

					// ====== 批次属性 ======
					"define1": pData.productskus[0].batchno_define1 ? pData.productskus[0].batchno_define1 : null,
					"define2": pData.productskus[0].batchno_define2 ? pData.productskus[0].batchno_define2 : null,
					"define3": pData.productskus[0].batchno_define3 ? pData.productskus[0].batchno_define3 : null,
					"define4": pData.productskus[0].batchno_define4 ? pData.productskus[0].batchno_define4 : null,
					"define5": pData.productskus[0].batchno_define5 ? pData.productskus[0].batchno_define5 : null,
					"define6": pData.productskus[0].batchno_define6 ? pData.productskus[0].batchno_define6 : null,
					"define7": pData.productskus[0].batchno_define7 ? pData.productskus[0].batchno_define7 : null,
					"define8": pData.productskus[0].batchno_define8 ? pData.productskus[0].batchno_define8 : null,
					"define9": pData.productskus[0].batchno_define9 ? pData.productskus[0].batchno_define9 : null,
					"define10": pData.productskus[0].batchno_define10 ? pData.productskus[0].batchno_define10 : null,
					"define11": pData.productskus[0].batchno_define11 ? pData.productskus[0].batchno_define11 : null,
					"define12": pData.productskus[0].batchno_define12 ? pData.productskus[0].batchno_define12 : null,
					"define13": pData.productskus[0].batchno_define13 ? pData.productskus[0].batchno_define13 : null,
					"define14": pData.productskus[0].batchno_define14 ? pData.productskus[0].batchno_define14 : null,
					"define15": pData.productskus[0].batchno_define15 ? pData.productskus[0].batchno_define15 : null,
					"define16": pData.productskus[0].batchno_define16 ? pData.productskus[0].batchno_define16 : null,
					"define17": pData.productskus[0].batchno_define17 ? pData.productskus[0].batchno_define17 : null,
					"define18": pData.productskus[0].batchno_define18 ? pData.productskus[0].batchno_define18 : null,
					"define19": pData.productskus[0].batchno_define19 ? pData.productskus[0].batchno_define19 : null,
					"define20": pData.productskus[0].batchno_define20 ? pData.productskus[0].batchno_define20 : null,
					"define21": pData.productskus[0].batchno_define21 ? pData.productskus[0].batchno_define21 : null,
					"define22": pData.productskus[0].batchno_define22 ? pData.productskus[0].batchno_define22 : null,
					"define23": pData.productskus[0].batchno_define23 ? pData.productskus[0].batchno_define23 : null,
					"define24": pData.productskus[0].batchno_define24 ? pData.productskus[0].batchno_define24 : null,
					"define25": pData.productskus[0].batchno_define25 ? pData.productskus[0].batchno_define25 : null,
					"define26": pData.productskus[0].batchno_define26 ? pData.productskus[0].batchno_define26 : null,
					"define27": pData.productskus[0].batchno_define27 ? pData.productskus[0].batchno_define27 : null,
					"define28": pData.productskus[0].batchno_define28 ? pData.productskus[0].batchno_define28 : null,
					"define29": pData.productskus[0].batchno_define29 ? pData.productskus[0].batchno_define29 : null,
					"define30": pData.productskus[0].batchno_define30 ? pData.productskus[0].batchno_define30 : null,

					// ====== 商品自定义项 ======
					"prodefine1": pData.define1 ? pData.define1 : null,
					"prodefine2": pData.define2 ? pData.define2 : null,
					"prodefine3": pData.define3 ? pData.define3 : null,
					"prodefine4": pData.define4 ? pData.define4 : null,
					"prodefine5": pData.define5 ? pData.define5 : null,
					"prodefine6": pData.define6 ? pData.define6 : null,
					"prodefine7": pData.define7 ? pData.define7 : null,
					"prodefine8": pData.define8 ? pData.define8 : null,
					"prodefine9": pData.define9 ? pData.define9 : null,
					"prodefine10": pData.define10 ? pData.define10 : null,
					"prodefine11": pData.define11 ? pData.define11 : null,
					"prodefine12": pData.define12 ? pData.define12 : null,
					"prodefine13": pData.define13 ? pData.define13 : null,
					"prodefine14": pData.define14 ? pData.define14 : null,
					"prodefine15": pData.define15 ? pData.define15 : null,
					"prodefine16": pData.define16 ? pData.define16 : null,
					"prodefine17": pData.define17 ? pData.define17 : null,
					"prodefine18": pData.define18 ? pData.define18 : null,
					"prodefine19": pData.define19 ? pData.define19 : null,
					"prodefine20": pData.define20 ? pData.define20 : null,
					"prodefine21": pData.define21 ? pData.define21 : null,
					"prodefine22": pData.define22 ? pData.define22 : null,
					"prodefine23": pData.define23 ? pData.define23 : null,
					"prodefine24": pData.define24 ? pData.define24 : null,
					"prodefine25": pData.define25 ? pData.define25 : null,
					"prodefine26": pData.define26 ? pData.define26 : null,
					"prodefine27": pData.define27 ? pData.define27 : null,
					"prodefine28": pData.define28 ? pData.define28 : null,
					"prodefine29": pData.define29 ? pData.define29 : null,
					"prodefine30": pData.define30 ? pData.define30 : null,

					// ====== SKU自定义项 ======
					"skudefine1": pData.productskus[0].sku_define1 ? pData.productskus[0].sku_define1 : null,
					"skudefine2": pData.productskus[0].sku_define2 ? pData.productskus[0].sku_define2 : null,
					"skudefine3": pData.productskus[0].sku_define3 ? pData.productskus[0].sku_define3 : null,
					"skudefine4": pData.productskus[0].sku_define4 ? pData.productskus[0].sku_define4 : null,
					"skudefine5": pData.productskus[0].sku_define5 ? pData.productskus[0].sku_define5 : null,
					"skudefine6": pData.productskus[0].sku_define6 ? pData.productskus[0].sku_define6 : null,
					"skudefine7": pData.productskus[0].sku_define7 ? pData.productskus[0].sku_define7 : null,
					"skudefine8": pData.productskus[0].sku_define8 ? pData.productskus[0].sku_define8 : null,
					"skudefine9": pData.productskus[0].sku_define9 ? pData.productskus[0].sku_define9 : null,
					"skudefine10": pData.productskus[0].sku_define10 ? pData.productskus[0].sku_define10 : null,
					"skudefine11": pData.productskus[0].sku_define11 ? pData.productskus[0].sku_define11 : null,
					"skudefine12": pData.productskus[0].sku_define12 ? pData.productskus[0].sku_define12 : null,
					"skudefine13": pData.productskus[0].sku_define13 ? pData.productskus[0].sku_define13 : null,
					"skudefine14": pData.productskus[0].sku_define14 ? pData.productskus[0].sku_define14 : null,
					"skudefine15": pData.productskus[0].sku_define15 ? pData.productskus[0].sku_define15 : null,
					"skudefine16": pData.productskus[0].sku_define16 ? pData.productskus[0].sku_define16 : null,
					"skudefine17": pData.productskus[0].sku_define17 ? pData.productskus[0].sku_define17 : null,
					"skudefine18": pData.productskus[0].sku_define18 ? pData.productskus[0].sku_define18 : null,
					"skudefine19": pData.productskus[0].sku_define19 ? pData.productskus[0].sku_define19 : null,
					"skudefine20": pData.productskus[0].sku_define20 ? pData.productskus[0].sku_define20 : null,
					"skudefine21": pData.productskus[0].sku_define21 ? pData.productskus[0].sku_define21 : null,
					"skudefine22": pData.productskus[0].sku_define22 ? pData.productskus[0].sku_define22 : null,
					"skudefine23": pData.productskus[0].sku_define23 ? pData.productskus[0].sku_define23 : null,
					"skudefine24": pData.productskus[0].sku_define24 ? pData.productskus[0].sku_define24 : null,
					"skudefine25": pData.productskus[0].sku_define25 ? pData.productskus[0].sku_define25 : null,
					"skudefine26": pData.productskus[0].sku_define26 ? pData.productskus[0].sku_define26 : null,
					"skudefine27": pData.productskus[0].sku_define27 ? pData.productskus[0].sku_define27 : null,
					"skudefine28": pData.productskus[0].sku_define28 ? pData.productskus[0].sku_define28 : null,
					"skudefine29": pData.productskus[0].sku_define29 ? pData.productskus[0].sku_define29 : null,
					"skudefine30": pData.productskus[0].sku_define30 ? pData.productskus[0].sku_define30 : null,
					"skudefine31": pData.productskus[0].sku_define31 ? pData.productskus[0].sku_define31 : null,
					"skudefine32": pData.productskus[0].sku_define32 ? pData.productskus[0].sku_define32 : null,
					"skudefine33": pData.productskus[0].sku_define33 ? pData.productskus[0].sku_define33 : null,
					"skudefine34": pData.productskus[0].sku_define34 ? pData.productskus[0].sku_define34 : null,
					"skudefine35": pData.productskus[0].sku_define35 ? pData.productskus[0].sku_define35 : null,
					"skudefine36": pData.productskus[0].sku_define36 ? pData.productskus[0].sku_define36 : null,
					"skudefine37": pData.productskus[0].sku_define37 ? pData.productskus[0].sku_define37 : null,
					"skudefine38": pData.productskus[0].sku_define38 ? pData.productskus[0].sku_define38 : null,
					"skudefine39": pData.productskus[0].sku_define39 ? pData.productskus[0].sku_define39 : null,
					"skudefine40": pData.productskus[0].sku_define40 ? pData.productskus[0].sku_define40 : null,
					"skudefine41": pData.productskus[0].sku_define41 ? pData.productskus[0].sku_define41 : null,
					"skudefine42": pData.productskus[0].sku_define42 ? pData.productskus[0].sku_define42 : null,
					"skudefine43": pData.productskus[0].sku_define43 ? pData.productskus[0].sku_define43 : null,
					"skudefine44": pData.productskus[0].sku_define44 ? pData.productskus[0].sku_define44 : null,
					"skudefine45": pData.productskus[0].sku_define45 ? pData.productskus[0].sku_define45 : null,
					"skudefine46": pData.productskus[0].sku_define46 ? pData.productskus[0].sku_define46 : null,
					"skudefine47": pData.productskus[0].sku_define47 ? pData.productskus[0].sku_define47 : null,
					"skudefine48": pData.productskus[0].sku_define48 ? pData.productskus[0].sku_define48 : null,
					"skudefine49": pData.productskus[0].sku_define49 ? pData.productskus[0].sku_define49 : null,
					"skudefine50": pData.productskus[0].sku_define50 ? pData.productskus[0].sku_define50 : null,
					"skudefine51": pData.productskus[0].sku_define51 ? pData.productskus[0].sku_define51 : null,
					"skudefine52": pData.productskus[0].sku_define52 ? pData.productskus[0].sku_define52 : null,
					"skudefine53": pData.productskus[0].sku_define53 ? pData.productskus[0].sku_define53 : null,
					"skudefine54": pData.productskus[0].sku_define54 ? pData.productskus[0].sku_define54 : null,
					"skudefine55": pData.productskus[0].sku_define55 ? pData.productskus[0].sku_define55 : null,
					"skudefine56": pData.productskus[0].sku_define56 ? pData.productskus[0].sku_define56 : null,
					"skudefine57": pData.productskus[0].sku_define57 ? pData.productskus[0].sku_define57 : null,
					"skudefine58": pData.productskus[0].sku_define58 ? pData.productskus[0].sku_define58 : null,
					"skudefine59": pData.productskus[0].sku_define59 ? pData.productskus[0].sku_define59 : null,
					"skudefine60": pData.productskus[0].sku_define60 ? pData.productskus[0].sku_define60 : null
				})
			};

			var findRow = function(productsku, isBatchManage, batchNo = '_invalid_value_') {
				var rowIndex = -1;
				var rows = detailsModel.getRows();
				var rowLength = rows.length;

				for(var i = 0; i < rowLength; i++) {
					if(rows[i]._status == 'Delete') {
						continue;
					}

					if(productsku == detailsModel.getCellValue(i, 'productsku')) {
						if(isBatchManage) {
							if(batchNo == detailsModel.getCellValue(i, 'batchno')) {
								rowIndex = i;
								break;
							} else {
								if(batchNo == '_invalid_value_') {
									rowIndex = i;
								}
							}
						} else {
							if(detailsModel.getCellValue(i, 'batchno') == undefined) {
								rowIndex = i;
								break;
							}
						}
					}
				}

				return rowIndex;
			};

			var getCurrentRowStock = function(rowIndex) {
				if(null != rowIndex && rowIndex !== undefined) {
					var isBatchManage = detailsModel.getCellValue(rowIndex, 'isBatchManage');
					var curBatchNo = null;

					if(isBatchManage) {
						curBatchNo = detailsModel.getCellValue(rowIndex, 'batchno');

						if(null == curBatchNo || curBatchNo === undefined) {
							return null;
						}
					}

					var curSku = detailsModel.getCellValue(rowIndex, 'productsku');
					var curWarehouseId = viewmodel.get("warehouse").getValue();

					if(null == curSku || curSku === undefined || null == curWarehouseId || curSku === curWarehouseId) {
						return null;
					}

					var params = {
						batchno: curBatchNo ? curBatchNo : "",
						warehouse: curWarehouseId,
						productsku: curSku,
						free1: detailsModel.getCellValue(rowIndex, 'free1'),
						free2: detailsModel.getCellValue(rowIndex, 'free2'),
						free3: detailsModel.getCellValue(rowIndex, 'free3'),
						free4: detailsModel.getCellValue(rowIndex, 'free4'),
						free5: detailsModel.getCellValue(rowIndex, 'free5'),
						free6: detailsModel.getCellValue(rowIndex, 'free6'),
						free7: detailsModel.getCellValue(rowIndex, 'free7'),
						free8: detailsModel.getCellValue(rowIndex, 'free8'),
						free9: detailsModel.getCellValue(rowIndex, 'free9'),
						free10: detailsModel.getCellValue(rowIndex, 'free10')
					};

					var queryStockProxy = cb.rest.DynamicProxy.create({
						settle: {
							url: '/bill/ref/getCurStock',
							options: {
								async: false
							},
							method: 'POST'
						}
					});

					var data = queryStockProxy.settle(params);
					var curAccountQty = null;

					if(data.error || data === undefined) {
						cb.utils.alert("查询商品库存异常！", 'error');
					} else {
						curAccountQty = parseFloat(data.result);
						// curAccountQty = parseInt(data.result);
					}

					return curAccountQty;

					// ====== 下面是异步方法 - 勿删！ ======
					// queryStockProxy.settle(params, (err, result) => {
					//   if (err) {
					//     cb.utils.alert(err.message, 'error');
					//     return;
					//   }
					//
					//   if(result === undefined) {
					//     cb.utils.alert("查询商品库存异常！", 'error');
					//     return;
					//   }
					//
					//   let curAccountQty = parseFloat(result);
					//   // let curAccountQty = parseInt(result);
					//   detailsModel.setCellValue(rowIndex, "accountQty", result, false, false);
					//
					//   return curAccountQty;
					// });
				}
			};

			// ====== 更新表体行差异类型及数量 ======
			// ====== 注：请勿在海量数据循环中使用, 请用下面的批量更新方法 ======
			var updateRowStockAndStatus = function(rowIndex) {
				var curAccountQty = detailsModel.getCellValue(rowIndex, 'accountQty');
				var curQuantity = detailsModel.getCellValue(rowIndex, 'quantity');
				var isBatchManage = detailsModel.getCellValue(rowIndex, 'isBatchManage');
				var batchno = detailsModel.getCellValue(rowIndex, 'batchno');

				if(null == curQuantity || curQuantity === undefined) {
					// cb.utils.alert("请先输入实盘数量！", 'error');
					return;
				}

				if(isBatchManage && (null == batchno || batchno === undefined)) {
					return;
				}

				curQuantity = parseFloat(curQuantity);
				// curQuantity = parseInt(curQuantity);

				if(null == curAccountQty || curAccountQty === undefined) {
					let curStock = getCurrentRowStock(rowIndex);

					if(null == curStock || curStock === undefined) {
						cb.utils.alert("查询存量失败", 'error');
						return;
					} else {
						//cb.utils.alert("正在请求查询存量......", 'warning');
						curAccountQty = parseFloat(curStock);
						// curAccountQty = parseInt(curStock);
						detailsModel.setCellValue(rowIndex, "accountQty", curStock, false, false);
					}
				}

				if(curQuantity > curAccountQty) {
					detailsModel.setCellValue(rowIndex, "vQuantity", curQuantity - curAccountQty, false, false);
					detailsModel.setCellValue(rowIndex, "vType", '盘盈', false, false);
				} else if(curQuantity < curAccountQty) {
					detailsModel.setCellValue(rowIndex, "vQuantity", curQuantity - curAccountQty, false, false);
					detailsModel.setCellValue(rowIndex, "vType", '盘亏', false, false);
				} else {
					detailsModel.setCellValue(rowIndex, "vQuantity", 0, false, false);
					detailsModel.setCellValue(rowIndex, "vType", '平', false, false);
				}
			};

			// ====== 批量更新表体行差异类型及数量 ======
			var batchUpdateRowStockAndStatus = function(rows) {
				if(null != rows && rows !== undefined && rows.length > 0) {
					let rowsSize = rows.length;

					for(let i = 0; i < rowsSize; i++) {
						let curRow = rows[i];
						let curAccountQty = curRow.accountQty;
						let curQuantity = curRow.quantity;

						if(null == curQuantity || curQuantity === undefined) {
							cb.utils.alert("请先输入实盘数量：第 " + i + "行！", 'error');
							continue;
						}

						curQuantity = parseFloat(curQuantity);
						// curQuantity = parseInt(curQuantity);

						if(null == curAccountQty || curAccountQty === undefined) {
							curAccountQty = getCurrentRowStock(rowIndex);

							if(null == curAccountQty || curAccountQty === undefined) {
								cb.utils.alert("第 " + i + "行查询存量失败！", 'error');
								continue;
							}
						}

						curRow.accountQty = parseFloat(curAccountQty);
						// curRow.accountQty = parseInt(curAccountQty);

						if(curQuantity > curAccountQty) {
							curRow.vQuantity = curQuantity - curAccountQty;
							curRow.vType = '盘盈';
						} else if(curQuantity < curAccountQty) {
							curRow.vQuantity = curQuantity - curAccountQty;
							curRow.vType = '盘亏';
						} else {
							curRow.vQuantity = 0;
							curRow.vType = '平';
						}
					}

					detailsModel.setDataSource(rows);
					detailsModel.setDirty(false);
				}
			};
      // *************************************************************************************************************
      // *                                       自 定 义 函 数 区 结 束                                              *
      // *************************************************************************************************************


			// viewmodel.get("barcode").on('enter', function (data) {
			//   var curMainId = viewmodel.get("id").getValue();
			//   var curIuputValue = data ? data : viewmodel.get("barcode").getValue();

			//   var queryProductProxy = cb.rest.DynamicProxy.create({
			//     settle: {
			//       url: '/bill/ref/getBarcodeResult.do',
			//       //url: '/mall/bill/ref/getProducts.do',
			//       method: 'POST'
			//     }
			//   });
			//   var params = {
			//     // token : '28f9169d2e2a491bb1804138e4357e29',
			//     isReturn : 0,
			//     keyword : curIuputValue

			//   };

			//   if (curIuputValue && detailsModel) {
			//     queryProductProxy.settle(params, (err, result) => {
			//       if (err) {
			//         cb.utils.alert(err.message, 'error');
			//         return;
			//       }

			//       if(result === undefined || JSON.stringify(result) == "{}") {
			//         cb.utils.alert("没有条码为[" + curIuputValue + "]的商品！", 'error');
			//         return;
			//       }

			//       let pData = result.data.recordList[0];
			//       let isBatchManage = pData.isBatchManage;
			//       let resultSku = pData.productskus["0"].skuId;
			//       let batchno = isBatchManage ? pData.productskus[0].batchno : "_invalid_value_";
			//       let curRowIndex = detailsModel.getSelectedRowIndexes()[0];

			//       var targetRow = findRow(resultSku, isBatchManage, batchno);

			//       if (targetRow != -1) {
			//         // ====== 发现相同数据行 ======
			//         curRowIndex = targetRow;

			//         let newQuantity = null;
			//         let tempQty = detailsModel.getCellValue(curRowIndex, 'quantity');

			//         if (null == tempQty || tempQty === undefined) {
			//           newQuantity = 1;
			//         } else {
			//           newQuantity = parseFloat(tempQty) + 1;
			//           // newQuantity = parseInt(tempQty) + 1;
			//         }

			//         detailsModel.setCellValue(curRowIndex, "quantity", newQuantity, false, false);
			//       } else {
			//         // ====== 未发现相同数据行 ======
			//         if (curRowIndex === undefined || curRowIndex === null) {
			//           // 1：没有行数据或尚未进行行操作(包括增行)
			//           appendNewRow(curMainId, result);
			//           curRowIndex = detailsModel.getRows().length - 1;
			//         } else {
			//           // 2：选择了某一行
			//           let curSku = detailsModel.getCellValue(curRowIndex, 'productsku');

			//           if (curSku === undefined || curSku === null || curSku ==='') {
			//             // 2-1：当前所在行是新增的空行
			//             updateCurrentRow(curRowIndex, curMainId, result);
			//           } else {
			//             // 2-2：当前所在行是其它行
			//             appendNewRow(curMainId, result);
			//             curRowIndex = detailsModel.getRows().length - 1;
			//           }
			//         }
			//       }

			//       if (!isBatchManage || (isBatchManage && detailsModel.getCellValue(curRowIndex, 'batchno'))) {
			//         updateRowStockAndStatus(curRowIndex);
			//       }

			//       /*
			//       let curRowIndex = detailsModel.getSelectedRowIndexes()[0];
			//       if (curRowIndex === undefined) {
			//         // ====== 未选择任何表体行 ======
			//         var targetRow = findRow(resultSku, isBatchManage, batchno);

			//         if (targetRow != -1) {
			//           curRowIndex = targetRow;
			//           //let curRow = detailsModel.getRow(curRowIndex);

			//           let newQuantity = null;
			//           let tempQty = detailsModel.getCellValue(curRowIndex, 'quantity');

			//           if (null == tempQty || tempQty === undefined) {
			//             newQuantity = 1;
			//           } else {
			//             newQuantity = parseFloat(tempQty) + 1;
			//             // newQuantity = parseInt(tempQty) + 1;
			//           }

			//           detailsModel.setCellValue(curRowIndex, "quantity", newQuantity, false, false);
			//         } else {
			//           appendNewRow(curMainId, result);
			//           curRowIndex = detailsModel.getRows().length - 1;
			//         }

			//         if (!isBatchManage || (isBatchManage && detailsModel.getCellValue(curRowIndex, 'batchno'))) {
			//           updateRowStockAndStatus(curRowIndex);
			//         }
			//       } else {
			//         // ====== 当前选择了一行 ======
			//         //let curRow = detailsModel.getRow(curRowIndex);

			//         if (detailsModel.getCellValue(curRowIndex, 'productsku') === resultSku &&
			//             (isBatchManage ? (detailsModel.getCellValue(curRowIndex, 'batchno') === batchno ? true : false) : true)) {
			//           let newQuantity = null;
			//           let tempQty = detailsModel.getCellValue(curRowIndex, 'quantity');

			//           if (null == tempQty || tempQty === undefined) {
			//             newQuantity = 1;
			//           } else {
			//             newQuantity = parseFloat(tempQty) + 1;
			//             // newQuantity = parseInt(tempQty) + 1;
			//           }

			//           detailsModel.setCellValue(curRowIndex, "quantity", newQuantity, false, false);

			//           if (!detailsModel.getCellValue(curRowIndex, 'accountQty')) {
			//             updateRowStockAndStatus(curRowIndex);
			//           }
			//         } else if (detailsModel.getCellValue(curRowIndex, 'productsku') === undefined ||
			//                    detailsModel.getCellValue(curRowIndex, 'productsku')  === null) {
			//           updateCurrentRow(curRowIndex, curMainId, result);

			//           // if (isBatchManage && detailsModel.getCellValue(curRowIndex, 'batchno')) {
			//           if (!isBatchManage || (isBatchManage && detailsModel.getCellValue(curRowIndex, 'batchno'))) {
			//             updateRowStockAndStatus(curRowIndex);
			//           }
			//         } else {
			//           var targetRow = findRow(resultSku, isBatchManage, batchno);

			//           if (targetRow != -1) {
			//             curRowIndex = targetRow;
			//             // let curRow = detailsModel.getRow(curRowIndex);

			//             let newQuantity = null;
			//             let tempQty = detailsModel.getCellValue(curRowIndex, 'quantity');

			//             if (null == tempQty || tempQty === undefined) {
			//               newQuantity = 1;
			//             } else {
			//               newQuantity = parseFloat(tempQty) + 1;
			//               // newQuantity = parseInt(tempQty) + 1;
			//             }

			//             // let newQuantity = null == curRow.quantity || curRow.quantity === undefined ? 1 : parseInt(curRow.quantity) + 1;
			//             detailsModel.setCellValue(curRowIndex, "quantity", newQuantity, false, false);
			//           } else {
			//             appendNewRow(curMainId, result);
			//             curRowIndex = detailsModel.getRows().length - 1;
			//           }

			//           // if (isBatchManage && detailsModel.getCellValue(curRowIndex, 'batchno')) {
			//           if (!isBatchManage || (isBatchManage && detailsModel.getCellValue(curRowIndex, 'batchno'))) {
			//             updateRowStockAndStatus(curRowIndex);
			//           }
			//         }
			//       }
			//       */

			//     });
			//   }

			//   viewmodel.get("barcode").setValue(null);
			// });

			detailsModel.on('afterCellValueChange', function(data) {
				let warehouse = viewmodel.get("warehouse").getValue();

				if(null == warehouse || warehouse === undefined || warehouse == '') {
					cb.utils.alert('未选择仓库！', 'error');
					return false;
				}

				var curRowIndex = data.rowIndex;

				switch(data.cellName) {
					// ====== 检查实盘数量为正数 ======
					case "quantity":
						{
							// var reg = /^[1-9]\d*$/;
							// var reg = /^\d+$/;
							// var reg = /^\d+(\.\d)?$/;
							var value = data.value;

							// if (!reg.test(value)) {
							if(value < 0) {
								cb.utils.alert("实盘数量只允许输入正数！", "warning");
								detailsModel.setCellValue(data.rowIndex, 'quantity', null);
								return false;
							}

							updateRowStockAndStatus(curRowIndex);

							break;
						}

						// ====== 检查实盘重量必需大于0 ======
					case "weight":
						{
							var value = data.value;

							if(value < 0) {
								cb.utils.alert("实盘重量必需大于等于0！", "warning");
								detailsModel.setCellValue(data.rowIndex, 'weight', null);
								return false;
							}

							break;
						}

						// ====== 检查实盘重量必需大于0 ======
					case "price":
						{
							var value = data.value;

							if(value < 0) {
								cb.utils.alert("实盘价格必需大于等于0！", "warning");
								detailsModel.setCellValue(data.rowIndex, 'price', null);
								return false;
							}

							break;
						}

					case "product_cCode":
						{
							let curProductsku = detailsModel.getCellValue(curRowIndex, 'productsku');
							let isBatchManage = detailsModel.getCellValue(curRowIndex, 'isBatchManage');
							let batchno = isBatchManage ? detailsModel.getCellValue(curRowIndex, 'batchno') : "_invalid_value_";

							detailsModel.setCellValue(curRowIndex, 'batchno', null);
							detailsModel.setCellValue(curRowIndex, 'producedate', null);
							detailsModel.setCellValue(curRowIndex, 'invaliddate', null);
							detailsModel.setCellValue(curRowIndex, 'define1', null);
							detailsModel.setCellValue(curRowIndex, 'define2', null);
							detailsModel.setCellValue(curRowIndex, 'define3', null);
							detailsModel.setCellValue(curRowIndex, 'define4', null);
							detailsModel.setCellValue(curRowIndex, 'define5', null);
							detailsModel.setCellValue(curRowIndex, 'define6', null);
							detailsModel.setCellValue(curRowIndex, 'define7', null);
							detailsModel.setCellValue(curRowIndex, 'define8', null);
							detailsModel.setCellValue(curRowIndex, 'define9', null);
							detailsModel.setCellValue(curRowIndex, 'define10', null);
							detailsModel.setCellValue(curRowIndex, 'define11', null);
							detailsModel.setCellValue(curRowIndex, 'define12', null);
							detailsModel.setCellValue(curRowIndex, 'define13', null);
							detailsModel.setCellValue(curRowIndex, 'define14', null);
							detailsModel.setCellValue(curRowIndex, 'define15', null);
							detailsModel.setCellValue(curRowIndex, 'define16', null);
							detailsModel.setCellValue(curRowIndex, 'define17', null);
							detailsModel.setCellValue(curRowIndex, 'define18', null);
							detailsModel.setCellValue(curRowIndex, 'define19', null);
							detailsModel.setCellValue(curRowIndex, 'define20', null);
							detailsModel.setCellValue(curRowIndex, 'define21', null);
							detailsModel.setCellValue(curRowIndex, 'define22', null);
							detailsModel.setCellValue(curRowIndex, 'define23', null);
							detailsModel.setCellValue(curRowIndex, 'define24', null);
							detailsModel.setCellValue(curRowIndex, 'define25', null);
							detailsModel.setCellValue(curRowIndex, 'define26', null);
							detailsModel.setCellValue(curRowIndex, 'define27', null);
							detailsModel.setCellValue(curRowIndex, 'define28', null);
							detailsModel.setCellValue(curRowIndex, 'define29', null);
							detailsModel.setCellValue(curRowIndex, 'define30', null);

							let targetRowIndex = findRow(curProductsku, isBatchManage, batchno);

							if(targetRowIndex != -1 && targetRowIndex != curRowIndex) {
								cb.utils.alert("发现已存在的行数据：第" + parseInt(targetRowIndex + 1) + "行！", "warning");
								detailsModel.deleteRows([curRowIndex]);
								detailsModel.select([targetRowIndex]);

								// cb.utils.confirm("发现已存在的行数据：第" + parseInt(targetRowIndex + 1) + "行；当前是第" + parseInt(curRowIndex + 1) + "行！删除当前行吗？", () => {
								//   detailsModel.deleteRows([curRowIndex]);
								//   detailsModel.select([targetRowIndex]);
								// }, () => {
								//   return;
								// });
							} else {
								if(!isBatchManage) {
									var curAccountQty = getCurrentRowStock(curRowIndex);
									detailsModel.setCellValue(curRowIndex, "accountQty", curAccountQty, false, false);
									updateRowStockAndStatus(curRowIndex);
								}
							}

							break;
						}
						// ====== 输入批次号后的业务处理逻辑 ======
					case "batchno":
						{
							// ====== 批次使用输入框的逻辑代码 ======
							// let curProductsku = detailsModel.getCellValue(curRowIndex, 'productsku');
							// let batchno = detailsModel.getCellValue(curRowIndex, 'batchno');
							//
							// let targetRowIndex = findRow(curProductsku, true, batchno);
							//
							// if (targetRowIndex != -1 && targetRowIndex != curRowIndex) {
							//   cb.utils.alert("发现已存在的行数据：第" + parseInt(targetRowIndex + 1) + "行！", "warning");
							//   detailsModel.deleteRows([curRowIndex]);
							//   detailsModel.select([targetRowIndex]);
							// } else {
							//   var curAccountQty = getCurrentRowStock(curRowIndex);
							//   detailsModel.setCellValue(curRowIndex, "accountQty", curAccountQty, false, false);
							//   updateRowStockAndStatus(data.rowIndex);
							// }

							// ====== 以下是批次使用参照的代码 ======
							let batchno = data.value.batchno;
							let producedate = data.value.producedate;
							let invaliddate = data.value.invaliddate;
							let define1 = data.value.define1;

							let curProductsku = detailsModel.getCellValue(curRowIndex, 'productsku');

							if(null == curProductsku || curProductsku === undefined || curProductsku == 0) {
								// ====== 多行选择导致新增的空行 ======
								if(curRowIndex > 0) {
									let tempRowIndex = curRowIndex - 1;
									let rowDada = detailsModel.getRow(tempRowIndex);

									detailsModel.updateRow(curRowIndex, rowDada);
								} else {
									cb.utils.alert("行数据出现意外错误，建议重新录入商品数据再进行批次录入操作！", 'error');
									return;
								}
							}

							detailsModel.setCellValue(curRowIndex, "batchno", batchno, false, false);
							detailsModel.setCellValue(curRowIndex, "producedate", producedate, false, false);
							detailsModel.setCellValue(curRowIndex, "invaliddate", invaliddate, false, false);
							detailsModel.setCellValue(curRowIndex, "accountWeight", define1, false, false);
							detailsModel.setCellValue(curRowIndex, "weight", define1, false, false);

							let targetRowIndex = findRow(curProductsku, true, batchno);

							if(targetRowIndex != -1 && targetRowIndex != curRowIndex) {
								cb.utils.alert("发现已存在的行数据：第" + parseInt(targetRowIndex + 1) + "行！", "warning");
								detailsModel.deleteRows([curRowIndex]);
								detailsModel.select([targetRowIndex]);

								// cb.utils.confirm("发现已存在的行数据：第" + parseInt(targetRowIndex + 1) + "行；当前是第" + parseInt(curRowIndex + 1) + "行！删除当前行吗？", () => {
								//   detailsModel.deleteRows([curRowIndex]);
								//   detailsModel.select([targetRowIndex]);
								// }, () => {
								//   return;
								// });
							} else {
								var curAccountQty = getCurrentRowStock(curRowIndex);
								detailsModel.setCellValue(curRowIndex, "accountQty", curAccountQty, false, false);
								updateRowStockAndStatus(data.rowIndex);
							}
						}
				}
			});

			// ====== 处理盘点机生成的附件 ===================================================================================
			viewmodel.get("btnAttachment").on('click', function() {
				let warehouse = viewmodel.get("warehouse").getValue();

				if(null == warehouse || warehouse === undefined || warehouse == '') {
					cb.utils.alert('未选择仓库！', 'error');
					return;
				}

				const eleInput = document.createElement('input');
				eleInput.type = 'file';
				eleInput.style.display = 'none';
				eleInput.onchange = function(event) {
					const reader = new FileReader();
					reader.onload = (e) => {
						onAttachment(e.target.result);
					};
					reader.readAsText(event.target.files[0]);
					document.body.removeChild(eleInput);
				};
				document.body.appendChild(eleInput);
				eleInput.click();
			});

			var onAttachment = function(data) {
				// ====== 正数正则 ======
				const regExp = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
				// const regExp = /^[1-9]\d*\.\d*|0\.\d*[1-9]\d*|0?\.0+|0$/;
				// const regExp = /^\+?[1-9][0-9]*$/;

				var queryProductProxy = cb.rest.DynamicProxy.create({
					settle: {
						url: '/bill/ref/getBarcodeResult.do',
						//url: '/mall/bill/ref/getProducts.do',
						method: 'POST'
					}
				});
				var params = {
					// token: '28f9169d2e2a491bb1804138e4357e29',
					isReturn: 0,
					keyword: ''
				};

				var dataMap = new Map();
				var curBarCode = null;
				var curNumber = null;

				var fData = data.replace(/\r+\n+/g, '__BirdMark__');
				var lines = fData.split('__BirdMark__');
				if(lines.length <= 0) {
					cb.utils.alert("所选文件没有任何数据！", 'error');
					return;
				}

				for(var i = 0; i < lines.length; i++) {
					var line = lines[i].trim();
					var strs = line.split(/\s+|\t+|,|;/g);

					if(strs.length <= 0) {
						continue;
					}

					if(strs.length > 2) {
						cb.utils.alert("数据格式错误！", 'error');
						dataMap = null;
						break;
					}

					if(strs.length == 1) {
						curBarCode = strs[0];

						if(curBarCode.trim() == "") {
							continue;
						}

						curNumber = 1;
					} else {
						curBarCode = strs[0];
						curNumber = strs[1];

						if(!regExp.test(curNumber)) {
							cb.utils.alert("数据格式错误！", 'error');
							dataMap = null;
							break;
						}
					}

					curNumber = parseFloat(curNumber);
					// curNumber = parseInt(curNumber);
					dataMap = pushNewData(dataMap, curBarCode, curNumber);
				}

				var curMainId = viewmodel.get("id").getValue();

				// cb.utils.confirm('清空表体重新导入？', () => {
				if(!confirm('清空表体重新导入？')) return;
				//detailsModel.clear();
				let rowsLength = detailsModel.getRows().length;
				let indexs = new Array();

				for(let i = 0; i < rowsLength; i++) {
					indexs.push(i);
				}

				detailsModel.deleteRows(indexs);

				for(let [key, value] of dataMap) {
					params.keyword = key;

					queryProductProxy.settle(params, (err, result) => {
						if(err) {
							cb.utils.alert(err.message, 'error');
							return;
						}

						if(result === undefined || JSON.stringify(result) == "{}") {
							cb.utils.alert("没有条码为[" + key + "]的商品！", 'error');
						} else {
							appendNewRow(curMainId, result, value);

							let curRowIndex = detailsModel.getRows().length - 1;
							let isBatchManage = detailsModel.getCellValue(curRowIndex, 'isBatchManage');
							let batchno = detailsModel.getCellValue(curRowIndex, 'batchno');

							if(!isBatchManage || (isBatchManage && batchno)) {
								updateRowStockAndStatus(curRowIndex);
							}
						}
					});
				}
				// }, () => {
				//   return;
				// });
			};
			// });

			// ====== 内部方法，用于构造包含导入数据的Map ======
			var pushNewData = function(map, key, value) {
				if(map.size <= 0 || !map.has(key)) {
					map.set(key, value);
				} else {
					var oldValue = map.get(key);
					map.set(key, parseFloat(value) + parseFloat(oldValue));
					// map.set(key, parseInt(value) + parseInt(oldValue));
				}

				return map;
			};

			// ====== 更换商店后刷新仓库 =====================================================================================
			viewmodel.get("store_name").on('afterValueChange', function(data) {
				var queryStoreProxy = cb.rest.DynamicProxy.create({
					settle: {
						url: '/bill/ref/getWarehouseByStore',
						method: 'POST'
					}
				});
				var params = {
					token: '28f9169d2e2a491bb1804138e4357e29',
					store: data.value.id
				};

				queryStoreProxy.settle(params, (err, result) => {
					if(err) {
						cb.utils.alert(err.message, 'error');
						return;
					}

					if(result === undefined) {
						cb.utils.alert("没有查询当前选择店铺的默认仓库！", 'error');
					} else {
						viewmodel.get("warehouse").setValue(result.warehouse);
						viewmodel.get("warehouse_name").setValue(result.warehouse_name);
					}
				});
			});

			// ====== 显示差异 ==============================================================================================
			viewmodel.get("btnCompare").on('click', function() {
				var rows = [];
				originDataSource.forEach(row => {
					rows.push(row);
				});
				detailsModel.setDataSource(rows);

				let rowsLength = detailsModel.getRows().length;

				for(var i = 0; i < rowsLength; i++) {
					updateRowStockAndStatus(i);
				}

				var newRows = [];
				originDataSource.forEach(row => {
					let vQuantity = parseFloat(row.vQuantity);

					// if (parseInt(row.vQuantity) != 0) {
					if(vQuantity > 0 || vQuantity < 0) {
						newRows.push(row);
					}
				});

				detailsModel.setDataSource(newRows);
			});

			// ====== 显示全部 ==============================================================================================
			viewmodel.get("btnEndCompare").on('click', function() {
				var rows = [];
				originDataSource.forEach(row => {
					rows.push(row);
				});
				detailsModel.setDataSource(rows);

				let rowsLength = detailsModel.getRows().length;

				for(var i = 0; i < rowsLength; i++) {
					updateRowStockAndStatus(i);
				}
			});

			// ====== 显示盘盈 ==============================================================================================
			viewmodel.get("btnProfitOnly").on('click', function() {
				var rows = [];
				originDataSource.forEach(row => {
					rows.push(row);
				});
				detailsModel.setDataSource(rows);

				let rowsLength = detailsModel.getRows().length;

				for(var i = 0; i < rowsLength; i++) {
					updateRowStockAndStatus(i);
				}

				var newRows = [];
				originDataSource.forEach(row => {
					if(row.vType == '盘盈') {
						newRows.push(row);
					}
				});

				detailsModel.setDataSource(newRows);
			});

			// ====== 显示盘亏 ==============================================================================================
			viewmodel.get("btnLossOnly").on('click', function() {
				var rows = [];
				originDataSource.forEach(row => {
					rows.push(row);
				});
				detailsModel.setDataSource(rows);

				let rowsLength = detailsModel.getRows().length;

				for(var i = 0; i < rowsLength; i++) {
					updateRowStockAndStatus(i);
				}

				var newRows = [];
				originDataSource.forEach(row => {
					if(row.vType == '盘亏') {
						newRows.push(row);
					}
				});

				detailsModel.setDataSource(newRows);
			});

			// ====== 提交 ==================================================================================================
			viewmodel.on('scsubmit', function(args) {
				var data = viewmodel.collectData(true);

				viewmodel.get("btnRowAudit").setDisabled(true);

				var submitProxy = cb.rest.DynamicProxy.create({
					ensure: {
						url: args.cSvcUrl,
						method: args.cHttpMethod
					}
				});
				var submitParams = {
					action: 'scSubmit',
					billnum: 'st_storecheck',
					data: JSON.stringify(data)
				};

				submitProxy.ensure(submitParams, function(err, result) {
					if(err) {
						cb.utils.alert(err.message, 'error');
						viewmodel.get("btnRowAudit").setDisabled(false);
						return;
					}

					cb.utils.alert('盘点单提交成功！', 'success');
					viewmodel.get("btnRowAudit").setDisabled(false);
					viewmodel.execute('refresh');
				});
			});

			// ====== 复盘 ==================================================================================================
			viewmodel.on('scunsubmit', function(args) {
				var data = viewmodel.collectData(true);
				data.details = [];

				viewmodel.get("btnUnaudit").setDisabled(true);

				var proxy = cb.rest.DynamicProxy.create({
					ensure: {
						url: args.cSvcUrl,
						method: args.cHttpMethod
					}
				});
				var params = {
					action: 'scUnSubmit',
					billnum: 'st_storecheck',
					data: JSON.stringify(data)
				};

				proxy.ensure(params, function(err, result) {
					if(err) {
						cb.utils.alert(err.message, 'error');
						viewmodel.get("btnUnaudit").setDisabled(false);
						return;
					}

					cb.utils.alert('成功将盘点单退回复盘！', 'success');
					viewmodel.get("btnUnaudit").setDisabled(false);
					viewmodel.execute('refresh');
				});
			});

			// ====== 确认复核（重写并替代原审核），不传表体数据 ==================================================================
			viewmodel.on('beforeAudit', function(args) {
				//如果请求来自保存并提交，那么不走这个事件，需要把事件转到scsubmit上去。
				if(args.params.cAction === 'saveandaudit') {
					var scsubmitParams = viewmodel.allActions && viewmodel.allActions.find(function (item){
						return item.cAction.trim().toLocaleLowerCase() === 'scsubmit';
					});
					viewmodel.execute('scsubmit', scsubmitParams);
					return false;
				}

				var data = viewmodel.collectData(true);
				data.details = [];

				viewmodel.get("btnAudit").setDisabled(true);

				args = {
					billnum: 'st_storecheck',
					data: JSON.stringify(data)
				};

				// var proxy = cb.rest.DynamicProxy.create({ensure: {url: args.cSvcUrl, method: args.cHttpMethod}});
				// var params = {
				//   action: 'audit',
				//   billnum: 'st_storecheck',
				//   data: JSON.stringify(data)
				// };
				//
				// proxy.ensure(params, function (err, result) {
				//   if (err) {
				//     cb.utils.alert(err.message, 'error');
				//     viewmodel.get("btnAudit").setDisabled(false);
				//     return;
				//   }
				//
				//   cb.utils.alert('确认复核成功！', 'success');
				//   viewmodel.get("btnAudit").setDisabled(false);
				//   viewmodel.execute('refresh');
				// });

				return true;
			});

			viewmodel.on('afterAudit', function(args) {
				// cb.utils.alert('确认复核成功！', 'success');
				viewmodel.get("btnAudit").setDisabled(false);
				viewmodel.execute('refresh');

				return true;
			});

			detailsModel.on('afterDeleteRows', function(data) {
				let rowLength = detailsModel.getRows().length;

				if(rowLength > 0) {
					// viewmodel.get("warehouse_name").setVisible(false);
					viewmodel.get("warehouse_name").setDisabled(true);
					// cb.utils.alert('表体已经有数据，不能更改仓库！', 'warning');
					// return false;
				} else {
					// viewmodel.get("warehouse_name").setVisible(true);
					viewmodel.get("warehouse_name").setDisabled(false);
					// return true;
				}

			});

			detailsModel.on('afterInsertRow', function(data) {
				let rowLength = detailsModel.getRows().length;

				if(rowLength > 0) {
					// viewmodel.get("warehouse_name").setVisible(false);
					viewmodel.get("warehouse_name").setDisabled(true);
					// cb.utils.alert('表体已经有数据，不能更改仓库！', 'warning');
					// return false;
				} else {
					// viewmodel.get("warehouse_name").setVisible(true);
					viewmodel.get("warehouse_name").setDisabled(false);
					// return true;
				}

			});

			viewmodel.get("warehouse_name").on('beforeBrowse', function(data) {
				let rowLength = detailsModel.getRows().length;

				if(rowLength > 0) {
					cb.utils.alert('表体已经有数据，不能更改仓库！', 'warning');
					return false;
				} else {
					return true;
				}
			});

			// viewmodel.get("warehouse_name").on('afterValueChange', function (data) {
			//   let rowLength = detailsModel.getRows().length;
			//
			//   if (rowLength > 0) {
			//     cb.utils.alert('表体已经有数据，不能更改仓库！', 'warning');
			//     return false;
			//   } else {
			//     return true;
			//   }
			// });

			// viewmodel.get("warehouse_name").on('beforeValueChange', function (data) {
			//   let rowLength = detailsModel.getRows().length;
			//
			//   if (rowLength > 0) {
			//     cb.utils.alert('表体已经有数据，不能更改仓库！', 'warning');
			//     return false;
			//   } else {
			//     return true;
			//   }
			// });

			// ====== 实盘单据时间不得小于盘点计划开始时间 ======
			viewmodel.get("vouchdate").on('afterValueChange', function(data) {
				var ret = true;

				var planCheckStartDate = planViewModel.get('checkStartTime').getValue();

				var minDate = Date.parse(planCheckStartDate);
				var thisDate = Date.parse(data.value);

				if(null != thisDate && minDate > thisDate) {
					cb.utils.alert('单据的业务时间不得小于盘点计划开始时间', 'warning');
					ret = false;
				}

				return ret;
			});

			// ====== 仓库变化前：表体已经有数据，不能更改仓库 ======
			viewmodel.get("warehouse_name").on('beforeValueChange', function(data) {
				let rowLength = detailsModel.getRows().length;

				if(rowLength > 0) {
					cb.utils.alert('表体已经有数据，不能更改仓库！', 'warning');
					return false;
				}
			});

			// ====== 仓库变化后：查询是否存在未复核的快速盘点和盘点计划，如果存在，不能更改仓库 ======
			viewmodel.get("warehouse_name").on('afterValueChange', function(data) {
				var promise = new cb.promise();

				if(data.value) {
					var wareh = data.value.id;
					var storecheckId = viewmodel.get("id").getValue();

					var wParams = {
						storecheck: storecheckId,
						wareh: wareh
					};

					var existStoreCheck = cb.rest.DynamicProxy.create({
						settle: {
							url: '/billingustock/existStoreCheckOrPlan',
							method: 'POST'
						}
					});

					existStoreCheck.settle(wParams, (err, result) => {
						if(err) {
							cb.utils.alert(err.message, 'error');
							return;
						}

						if(result === undefined) {
							cb.utils.alert("查询盘点数据异常！", 'error');
							return;
						}

						if(result != null && result != undefined && result !== '') {
							if(result == false || result == 'false') {
								promise.resolve();
							} else {
								cb.utils.alert("该仓库下存在未复核的盘点数据，不允许新增！", 'error');
								viewmodel.get("warehouse").setValue(null);
								viewmodel.get("warehouse_name").setValue('');
							}
						}
					});
				}

				return promise;
			});

			// ====== 增行前判断仓库 ======
			viewmodel.on('beforeAddRow', function(data) {
				let ret = true;
				let warehouse = viewmodel.get("warehouse").getValue();

				if(null == warehouse || warehouse === undefined || warehouse == '') {
					cb.utils.alert('未选择仓库！', 'error');
					ret = false;
				}

				return ret;
			});

			// viewmodel.on('beforeSave', function(args) {
			//   // ====== 校验仓库是否有未复核的快速盘点以及盘点计划 ======
			//   var storecheckId = viewmodel.get("id").getValue();
			//   var wareh = viewmodel.get("warehouse").getValue();
			//
			//   var wParams = {
			//     storecheck: storecheckId,
			//     wareh: wareh
			//   };
			//
			//   var existStoreCheck = cb.rest.DynamicProxy.create({
			//     settle: {
			//       url: '/billingustock/existStoreCheckOrPlan',
			//       method: 'POST'
			//     }
			//   });
			//
			//   existStoreCheck.settle(wParams, (err, result) => {
			//     if(err) {
			//       cb.utils.alert(err.message, 'error');
			//       return false;
			//     }
			//
			//     if(result === undefined) {
			//       cb.utils.alert("查询盘点数据异常！", 'error');
			//       return false;
			//     }
			//
			//     if(result != null && result != undefined && result !== '') {
			//       if(result == true  || result == 'true') {
			//         cb.utils.alert("该仓库下存在未复核的盘点数据，不允许保存！", 'error');
			//         viewmodel.get("warehouse").setValue(null);
			//         viewmodel.get("warehouse_name").setValue('');
			//       } else {
			//         return true;
			//       }
			//     }
			//   });
			// });

      // ====== 点击编辑按钮后：处理按钮可见性 ======
      viewmodel.on('afterEdit', function(data) {
        handleButtonsVisibilityByBrowseMode(false);
      });

		}
	};

	try {
		module.exports = ST_st_storecheck_VM_Extend;
	} catch(error) {

	}
	return ST_st_storecheck_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/ST/ST_st_storecheck_VM.Extend.js